<template>
    <div class="header">
        <Header>
            <div class="layout-logo">
                <img src="../../assets/images/logo.svg" alt="">
            </div>
            <div class="layout-title">{{roleCodes.includes('adjustment') ? '物资调剂管理平台' : '物资竞价采购平台'}}</div>
            <div class="layout-nav">
                <div v-if="version_name" style="font-size: 16px; font-weight: 600; color: #E50112;">（{{version_name}}）</div>
            </div>
            <div class="layout-subnav">
                <div class="message" @click="goToNoticeList" v-if="!roleCodes.includes('adjustment')">
                    <Icon :class="(counts && counts > 0 ? 'anim-bell' : 'bell')" type="md-notifications" />待查看消息 <span>{{counts > 0 ? counts : '0'}}</span> 条
                </div>
                <MenuItem name="1">
                    <Dropdown trigger="click">
                        <span v-if="!roleCodes.includes('adjustment')"></span>&nbsp;&nbsp;&nbsp;&nbsp;您好，{{ username }}
                        <a href="javascript:void(0)">
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem @click.native="handleEditPassword">修改密码</DropdownItem>
                            <DropdownItem @click.native="logout">退出系统</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </MenuItem>
            </div>
        </Header>

        <editPassword v-model="showEditPsdModal" :roleCodes="roleCodes"></editPassword>
    </div>
</template>
<script>
import {SERVER_ENV} from '@/common/portConfig';
import {jwtDecode} from 'jwt-decode';
import {reqGetCountsOfUnreadNotice} from "../../api/admin-api";
import editPassword from "./EditPassword";

export default {
    components: {editPassword},
    data() {
        return {
            showEditPsdModal: false,
            version_name: null,
            username: null,
            counts: 0,
            intervalTask: null,
            roleCodes: []
        }
    },
    methods: {
        goToNoticeList() {
            this.$emit('goToPage', '站内消息列表');
        },
        handleEditPassword() {
            this.showEditPsdModal = true;
        },
        logout() {
            this.$Modal.confirm({
                title: ' ',
                content: '确定退出系统',
                width: '240',
                onOk: () => {
                    sessionStorage.removeItem('un');
                    sessionStorage.removeItem('Authorization');
                    sessionStorage.removeItem('name');
                    sessionStorage.removeItem('isPsdChanged');
                    if (this.roleCodes.includes('adjustment')) {
                        this.$router.push('/login');
                    } else {
                        this.$router.push('/loginOthers');
                    }
                }
            });
        },
    },
    mounted() {
        if (SERVER_ENV === 'dev') {
            this.version_name = '开发版';
        } else if (SERVER_ENV === 'uat') {
            this.version_name = '测试版';
        } else {
            this.version_name = null;
        }

        let token = sessionStorage.getItem('Authorization');
        this.roleCodes = jwtDecode(token).roleCode.split(',').map(role => role.trim()) || [];

        this.username = sessionStorage.getItem('name') || sessionStorage.getItem('un');
        // 定时器模拟实时获取未读消息数量
        this.intervalTask = setInterval(() =>{
            reqGetCountsOfUnreadNotice().then((res) => {
                this.counts = res.data.data || 0;
            }).catch(() => {
                this.counts = 0;
            })
        }, 5000);
    },
    beforeDestroy() {
        // 清除定时器
        if (this.intervalTask) {
            clearInterval(this.intervalTask);
        }
    }
}
</script>
